<div class="config-wrapper">
  <div class="section">
    <h3>{{ 'archive:External Playback page configuration parameters' | i18next }}</h3>
    <div class="section-content thin-scroll">
      <div>{{ 'archive:Logo' | i18next }}</div>
      <div>
        <input #csvInput hidden="true" type="file" onclick="this.value=null" (change)="logoInputChange($event)"
          accept="image/png, image/jpeg" />
        <button mat-flat-button [ngClass]="['primary-button']" (click)="csvInput.click()">{{ 'archive:Select company logo' | i18next }}</button>
        <img *ngIf="logo" [src]="logo" alt="Logo" class="logo" />
      </div>
      <div>{{ 'archive:Footer on web page (1-3 lines)' | i18next }}</div>
      <div><textarea name="footer" [(ngModel)]="configData.footerText" rows="5" class=" thin-scroll"></textarea></div>
      <div>{{ 'archive:Web session time to live, in hours (1-24)' | i18next }}</div>
      <div>
        <input type="number" [(ngModel)]="configData.sessionDuration" min="1" max="24" step="1" class="number-input" required  #sessionDuration="ngModel"
              [class.alert]="sessionDuration.errors && (sessionDuration.dirty || sessionDuration.touched)" />

      </div>
        <div>{{ 'archive:Terms of use' | i18next }} - English</div>
        <div>
          <textarea [(ngModel)]="configData?.multilingual.en.terms" rows="7" class="thin-scroll" required minlength="1" #langEn="ngModel"
          [class.alert]="langEn.errors && (langEn.dirty || langEn.touched)" ></textarea>
        </div>

      <ng-container *ngFor="let lang of langs">
         <ng-container *ngIf="lang.key!='en'">
          <div>{{ 'archive:Terms of use' | i18next }} - {{lang.value}}</div>
          <div>
            <textarea [(ngModel)]="configData?.multilingual[lang.key].terms" rows="7" class="thin-scroll"></textarea>
          </div>
         </ng-container>
      </ng-container>
    </div>
    <div class="config-footer">
      <button (click)="saveConfig()" mat-flat-button [ngClass]="['primary-button']" [disabled]="sessionDuration.errors || langEn.errors">{{ 'archive:Save' | i18next }}</button>
      <button (click)="resetConfig()" mat-flat-button [ngClass]="['secondary-button']">{{ 'archive:Undo changes' | i18next }}</button>
    </div>
  </div>
</div>


